<template>
  <popup
    class="c-abnormal-prompt-popup"
    ref="popupRef"
    title="提示"
    base-confirm-text="我知道了"
    :baseButtons="[CONFIRM_EVENT]"
    :has-close-button="false"
    :mask-click="appStore.abnormalPromptPopupConfig.maskClick"
    @confirm="handleConfirm"
  >
    <view class="main"> {{ computeMessage }} </view>
  </popup>
</template>

<script setup lang="ts">
import { CONFIRM_EVENT, ERROR_MESSAGE } from '@/constants';
import { useAppStore } from '@/store';
import { onShow } from '@dcloudio/uni-app';
import { computed, onMounted, ref } from 'vue';

const appStore = useAppStore();

const popupRef = ref();

const computeMessage = computed(() => {
  return appStore.abnormalPromptPopupConfig.message || ERROR_MESSAGE.system;
});

const handleConfirm = () => {
  appStore.abnormalPromptPopupConfig.ref?.close?.();

  appStore.abnormalPromptPopupConfig.callback?.();

  setTimeout(() => {
    appStore.abnormalPromptPopupConfig = {
      ...appStore.abnormalPromptPopupConfig,
      message: '',
      maskClick: false,
      callback: null,
    };
  }, 500);
};

const refHandler = () => {
  appStore.abnormalPromptPopupConfig.ref = popupRef;
};

onMounted(() => {
  refHandler();
});

onShow(() => {
  // 由于组件放置在page组件里，页面切换后需重新赋值，保证当前实例的统一
  refHandler();
});
</script>

<style scoped lang="scss">
.c-abnormal-prompt-popup {
  position: relative;
  z-index: 9999;

  .main {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 28rpx;
    color: $N7;
  }
}
</style>
